import React from "react";
import { useNavigate } from "react-router";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHouse } from "@fortawesome/free-solid-svg-icons";
import { Context } from "../../App";
import PhotoTile from "../../Components/PhotoTile";
import SpotifyPlayer from "../../Components/SpotifyPlayer";
import { WeatherComponent } from "../../Components/WeatherTile";
import GoogleCalendarViewer from "../../Components/GoogleCalendarViewer";
import { BBCNews } from "../../Components/BBCNews";
import { ShoppingList } from "../../Components/ShoppingList";
import { Panel, PanelGroup } from "../../Components/Panel";
import { pad2, shortZone, useNow } from "../../services/useNow";
import HouseScene from "../../Components/HouseScene";

function TopBar() {
  const navigate = useNavigate();
  const { weather } = React.useContext(Context);
  const now = useNow(1000);
  const place = weather?.location?.name;

  return (
    <header className="topbar">
      <div className="topbar__crumbs">
        <span className="topbar__mark" aria-hidden />
        <span>Wyllie Home</span>
        <span className="topbar__sep">/</span>
        <span>Hub</span>
        {place && (
          <>
            <span className="topbar__sep">/</span>
            <strong>{place}</strong>
          </>
        )}
      </div>

      <div className="topbar__right">
        <span className="topbar__clock">
          {pad2(now.getHours())}:{pad2(now.getMinutes())}:
          {pad2(now.getSeconds())} {shortZone(now)}
        </span>
        <span className="topbar__assistant" title="Assistant coming soon">
          <span className="topbar__dot" aria-hidden />
          Assistant · standby
        </span>
        <button
          type="button"
          className="topbar__menu"
          onClick={() => navigate("/")}
        >
          <FontAwesomeIcon icon={faHouse} />
          Menu
        </button>
      </div>
    </header>
  );
}

function Clock() {
  const now = useNow(1000);
  const date = now
    .toLocaleDateString("en-GB", {
      weekday: "long",
      day: "numeric",
      month: "short",
      year: "numeric",
    })
    .replace(",", " ·");

  return (
    <div className="clock">
      <div className="clock__time">
        {pad2(now.getHours())}
        <span className="clock__colon">:</span>
        {pad2(now.getMinutes())}
        <span className="clock__sec">{pad2(now.getSeconds())}</span>
      </div>
      <div className="clock__date">{date}</div>
    </div>
  );
}

export default function Home() {
  const { currentPhotoStyle, weather, showingHouse } =
    React.useContext(Context);

  return (
    <div className={`hub ${showingHouse ? "hub--house" : ""}`}>
      <div className="hub__photo" style={currentPhotoStyle} aria-hidden />
      <div className="hub__dots" aria-hidden />

      <TopBar />

      <PanelGroup className="hub__side">
        <Panel className="hub__primary">
          <div className="brand">
            <span className="brand__name">[Wyllie/Home]</span>
            <span className="brand__flag" aria-hidden />
          </div>
          <Clock />
          <div className="hatch" />
          {weather && <WeatherComponent />}
        </Panel>
        <Panel className="hub__audio">
          <SpotifyPlayer />
        </Panel>
      </PanelGroup>

      <main className="hub__stage">
        {showingHouse && (
          <HouseScene />
        )}
        <PhotoTile />
      </main>

      <PanelGroup row className="hub__dock">
        <Panel className="dock__calendar">
          <GoogleCalendarViewer
            clientId={process.env.REACT_APP_GOOGLE_CAL_CLIENT_ID!}
          />
        </Panel>
        <Panel className="dock__shopping">
          <ShoppingList />
        </Panel>
        <Panel className="dock__news">
          <BBCNews />
        </Panel>
      </PanelGroup>
    </div>
  );
}
